export default __webpack_public_path__ + "assets/favicon/S_favicon_default.6918869a.ico";